<template>
	<div class="section row1 clear">
		<h2 class="fl" v-html="$i18nUtil.trans('message.HomeContents.005','새로 요청<br />받은 작업')"></h2>
		<div class="fr nodata" v-if="newWorkList.length === 0">
			<div>
				<div class="txt">{{ $i18nUtil.trans("search.001", "새로 요청받은 작업이 없습니다.") }}</div>
			</div>
		</div>
		<ul class="fr" v-if="newWorkList.length > 0">
			<li v-for="(item, index) in newWorkList" :key="index">
				<span class="label-fin" v-if="item.type === 'TODO'">{{ $i18nUtil.trans("entity.todo","할 일") }}</span>
				<span class="label-fin" v-if="item.type === 'DEC'">{{ $i18nUtil.trans("entity.decision","의사결정") }}</span>
				<span class="label-fin" v-if="item.type === 'FEEDBACK'">{{ $i18nUtil.trans("entity.feedback","피드백") }}</span>
				<div
					class="ell-singleline"
					@click="showLayer(item.type, item.id, item.obj, item.extParam1, item.extParam2)"
				>
					{{ item.contents }}
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import TodoInfo from "@/components/cowork/general/board/todo/popup/TodoInfo.vue";
import MyModalU from "@/components/cowork/general/board/opinion/BoardOpinionModalU.vue"
import Dialog from "@/components/cowork/common/alertMessage/Dialog";

export default {
	props: [
		'newWorkList'
	],
	methods: {
    ...mapActions("modals", ["showModal"]),
    ...mapActions("modals", ["showDialog"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),

		showLayer(type, id, obj, extParam1, extParam2) {
      let modalInfo = {
        method: "post",
        obj: this.$modal,
      };
      if (type === "DEC") {
        modalInfo.width = "800px",
        modalInfo.item = obj;
        modalInfo.name = "MyModalU";
        modalInfo.component = MyModalU;
        this.showModal(modalInfo);
      } else if (type === "TODO") {
        modalInfo.todoId = id;
        (modalInfo.width = "800px"),
          (modalInfo.height = "615px"),
          (modalInfo.name = "TodoInfo");
        modalInfo.component = TodoInfo;
        this.showModal(modalInfo);
      } else if (type === "FEEDBACK") {
        this.getFeedbackReqYn(id, extParam1, extParam2);
        // 피드백은 별도 팝업으로 호출함
      } else {
        this.showModal(modalInfo);
      }      
    },
		getFeedbackReqYn(feedbackId, paperId, qrtCd) {
      let obj = this;
      let reqData = {};
      reqData.params = {
        paperId: paperId,
        qrtCd: qrtCd,
        locale: obj.$i18nUtil.getLanguage()
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/okr/getFeedbackReqYn";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode == null) {
            let reqYn = res.result.FEEDBACK_REQ_YN;
            let reqMsq = res.result.FEEDBACK_REQ_MSG;
            if (reqYn == "0") {
              const dialogInfo = {
                  obj: obj.$modal,
                  component: Dialog,
                  title : obj.$i18nUtil.trans("title.dialog.notice","알림"),
                  button : obj.$i18nUtil.trans("button.dialog.confirm", "확인"),
                  subButton : null,
                  contents : reqMsq
              };
              this.showDialog(dialogInfo);              
            } else {
              let openUrl = "/neo/branch/common/slo/loginOKR.mvc?destination=feedbackAns&feedbackId=" + feedbackId;
              window.open(
                openUrl,
                "_blank",
                "width=838, height=750, scrollbars=no"
              );
            }
          } else {
            console.log(res.errorCode);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/home/base/RequestedJobs.vue